import { createModel } from "@rematch/core";

import type { RootModel } from '.';
import { PaginationFactory } from '../factory';
import { ReportTypes } from '../types';

export interface ReportStoreProps {
    pagination: PaginationFactory<ReportTypes.Model>,
    loading: {
        fetchMany: boolean,
        delete: boolean,
    },
};

export const reportsInitialState = {
    pagination: {} as PaginationFactory<ReportTypes.Model>,
    loading: {
        fetchMany: false,
        delete: false,
    },
};

export const report = createModel<RootModel>()({
    state: reportsInitialState,
    reducers: {
        boot: (store) => {
            store = reportsInitialState;
        },
        toggleLoading: (
            store, prop: keyof ReportStoreProps['loading'], v: boolean) => {
                store.loading[prop] = v;
            },
        setPagination: 
            (store, pagination: PaginationFactory<ReportTypes.Model>) => {
                store.pagination = pagination;
            },
        destroyReport: 
            (store, id: string) => {
                store.pagination.items = store.pagination.items.filter(i => i.id !== id);
            },
    },
});
